module.exports = __webpack_public_path__ + "static/media/xg2.01db1df2.png";